class HHCountdown extends HTMLElement {
  constructor() {
    super()

    this.interval = null
    this.seconds = null

    this.$daysTextTens = this.querySelector('.js-countdown-days-tens')
    this.$daysTextOnes = this.querySelector('.js-countdown-days-ones')
    this.$hoursTextTens = this.querySelector('.js-countdown-hours-tens')
    this.$hoursTextOnes = this.querySelector('.js-countdown-hours-ones')
    this.$minutesTextTens = this.querySelector('.js-countdown-minutes-tens')
    this.$minutesTextOnes = this.querySelector('.js-countdown-minutes-ones')
    this.$secondsTextTens = this.querySelector('.js-countdown-seconds-tens')
    this.$secondsTextOnes = this.querySelector('.js-countdown-seconds-ones')
  }

  get initialCountdownSeconds() {
    const int = Number.parseInt(this.getAttribute('data-countdown-seconds'), 10);
    if (Number.isNaN(int) || !int) {
      return 0;
    }

    return int;
  }

  connectedCallback() {
    this.seconds = this.initialCountdownSeconds
    this.updateTime();

    this.interval = setInterval(() => {
      this.updateTime()
      this.seconds -= 1
    }, 1000)
  }

  disconnectedCallback() {
    clearInterval(this.interval)
  }

  setDays(days) {
    const tens = Math.floor(days / 10)
    const ones = days % 10
    this.$daysTextTens.innerText = tens
    this.$daysTextOnes.innerText = ones
  }

  setHours(hours) {
    const tens = Math.floor(hours / 10)
    const ones = hours % 10
    this.$hoursTextTens.innerText = tens
    this.$hoursTextOnes.innerText = ones
  }

  setMinutes(minutes) {
    const tens = Math.floor(minutes / 10)
    const ones = minutes % 10
    this.$minutesTextTens.innerText = tens
    this.$minutesTextOnes.innerText = ones
  }

  setSeconds(seconds) {
    const tens = Math.floor(seconds / 10)
    const ones = seconds % 10
    this.$secondsTextTens.innerText = tens
    this.$secondsTextOnes.innerText = ones
  }

  updateTime() {
    if (this.seconds <= 0) {
      this.setDays(0)
      this.setHours(0)
      this.setMinutes(0)
      this.setSeconds(0)

      clearInterval(this.interval)
      this.classList.add('hidden')
    } else {
      const secondsRemainder = this.seconds % 60
      const minutes = Math.floor(this.seconds / 60)
      const hours = Math.floor(minutes / 60)
      const minutesRemainder = minutes % 60
      const days = Math.floor(hours / 24)
      const hoursRemainder = hours % 24

      this.setDays(days)
      this.setHours(hoursRemainder)
      this.setMinutes(minutesRemainder)
      this.setSeconds(secondsRemainder)
    }
  }
}

customElements.define('hh-countdown', HHCountdown)